import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-company-list',
  templateUrl: './company-list.component.html',
  styleUrls: ['./company-list.component.css']
})
export class CompanyListComponent {
  apiUrl = environment.apiUrl;

  get wForm(): string {
    const img = 'W9Form.jpg'

    return img
      ? `${this.apiUrl}/uploads/cyb/${img}`
      : '';
  }

  get doc(): string {
    const print = 'Print.pdf'

    return print
      ? `${this.apiUrl}/uploads/cyb/${print}`
      : '';
  }

  get EInNumber(): string {
    const EInNumber = 'EInNumber.pdf'

    return EInNumber
      ? `${this.apiUrl}/uploads/cyb/${EInNumber}`
      : '';
  }

  get corpPaper(): string {
    const corpPaper = 'CorpPaper.pdf'

    return corpPaper
      ? `${this.apiUrl}/uploads/cyb/${corpPaper}`
      : '';
  }
}
